/* import __COLOCATED_TEMPLATE__ from './reviewable-field-text.hbs'; */
import Component from "@ember/component";

export default class ReviewableFieldText extends Component {}
